import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type SwapNodeOptions = {} & SimpleManaNodeOptions

export default class SwapNode extends SimpleManaNode {

	static nodeType = 'SwapNode'
	static nodeName = "Swap node"
	static nodeDesc = "Swaps the positions of the caster and the target"
	static nodeIcon = '🔀'
	static category = NodeCategories.Force

	async act(particle: ManaParticle) {

		const tempPosition = particle.target.position.clone();

		particle.target.position.copy(particle.caster.position)
		particle.caster.position.copy(tempPosition)

		return true
	}

}